import type { oz } from '@weft/utils';
import { ProductVariantInputSchema } from '../product-variant-input-schema';
import { UsagePricingInputSchema } from './usage-pricing-input-schema';

export const UsageProductVariantInputSchema = ProductVariantInputSchema
  .extend({
    pricing: UsagePricingInputSchema,
  })
  .openapi('UsageProductVariantInput');

export type UsageProductVariantInput = oz.infer<typeof UsageProductVariantInputSchema>;